import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import ListItem from './ListItem'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'components/fulcrum/input/NumberInput'
import DeleteButton from './DeleteButton'

import styles from './styles.scss'

const InputConnectorRow = (props) => {
  const {
    source,
    count,
    connector,
    onConnectorChange,
    onCountChange,
    onRemove,
  } = props

  return (
    <ListItem>
      <Dropdown
        pos='left'
        onChange={onConnectorChange}
        source={source}
        value={connector}/>
      <Input
        pos='right'
        hint='Enter Connector Count'
        onChange={onCountChange}
        value={count}/>
      <DeleteButton
        pos='rightAction'
        onClick={onRemove}/>
    </ListItem>
  )
}

InputConnectorRow.propTypes = {
  source: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  connector: PropTypes.string.isRequired,
  onConnectorChange: PropTypes.func.isRequired,
  onCountChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default CSSModules(InputConnectorRow, styles)
